module.exports = __webpack_public_path__ + "img/logo-dark.c142c603.svg";